export default class DownloadKeyFormModule {

  /**
   * @param {Element} element
   */
  constructor (element) {
    this.element = element;
    this.init();
    this.registerEvents();
  }

  init () {
    this.form = this.element.querySelector('form');
    this.submit = this.element.querySelector('[type="submit"]');
  }

  registerEvents () {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  validateField (selector, message) {
    const field = this.form.querySelector(selector);

    field.classList.add('is-valid');
    field.insertAdjacentHTML('afterend', message);
  }

  invalidateField (selector, message) {
    const field = this.form.querySelector(selector);

    field.classList.add('is-invalid');
    field.insertAdjacentHTML('afterend', message);
  }

  resetFormValidation () {
    const fields = this.form.querySelectorAll('input');
    const messages = this.form.querySelectorAll('.valid-feedback, .invalid-feedback');

    fields?.forEach(field => field.classList.remove('is-valid', 'is-invalid'));
    messages?.forEach(message => message.remove());
  }

  resetForm () {
    this.resetFormValidation();
    this.element.querySelector('.alert')?.remove();
  }

  handleSubmit (event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const data = {
      security: formData.get('_wpnonce'),
      form_data: Object.fromEntries(formData.entries()),
    };

    fetch(window.DGFM.ajaxUrl + '?action=dgfm/download_key_submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const text = await response.text();
      let payload = {};
      try {
        payload = JSON.parse(text);
        console.log(payload);
      } catch (e) {
        console.error('Unexpected response:', text);
      }

      this.resetForm();

      const { messages } = payload.data;

      if (!payload?.success) {
        messages?.forEach(message => this.invalidateField(message.selector, message.message));
      } else {
        window.open(payload.data.url, '_blank', 'noopener');
        messages?.forEach(message => this.validateField(message.selector, message.message));
        this.form.insertAdjacentHTML('afterend', payload.data.download_prompt);
      }
    });
  }

}